import { createSelector } from 'reselect';
import { createSelectorDeep } from 'reselects/misc';
import _ from 'lodash';

const getPlainData = (state) => state.journeys.plainData;

const getJourneysObject = createSelector(
  (state) => state.journeys.plainData,
  (journeysObject) => journeysObject
);

const getTotalsByDate = (state) => state.journeys.totalsByDate;
const getTotalsByDriver = (state) => state.journeys.totalsByDriver;
const getTotalByNoOwner = (state) => state.journeys.totalsByNoOwner;
const getCostByDate = (state) => state.journeys.costByDate;
const getReviewStatus = (state) => state.journeys.reviewStatus;
const getMunicipalities = (state) => [];

const _getJourneySelectorProps = (_, journeyId, fields) => ({
  journeyId,
  fields,
});

const _getStopSelectorProps = (_, journeyId, stopId, fields) => ({
  journeyId,
  stopId,
  fields,
});

const getJourneyFields = createSelector(
  getJourneysObject,
  _getJourneySelectorProps,
  (journeys, { journeyId, fields }) => {
    return _.pick(journeys.get(journeyId), fields);
  }
);

const getJourneyAdditionalDocumentsFields = createSelector(
  getJourneysObject,
  _getJourneySelectorProps,
  (journeys, { journeyId }) => {
    const journey = journeys.get(journeyId);

    return {
      additional_documents:
        journey &&
        journey.shipper_orders &&
        journey.shipper_orders.some(
          (shipper_order) =>
            shipper_order &&
            shipper_order.additional_documents &&
            shipper_order.additional_documents.length > 0
        ),
      need_to_be_printed:
        journey &&
        journey.shipper_orders &&
        journey.shipper_orders.some(
          (shipper_order) =>
            shipper_order &&
            shipper_order.additional_documents &&
            shipper_order.additional_documents.map(
              (additional_document) =>
                additional_document.need_to_be_printed &&
                additional_document.need_to_be_printed === true
            )
        ),
    };
  }
);

const getJourneyStopFields = createSelector(
  getJourneysObject,
  _getStopSelectorProps,
  (journeys, { journeyId, stopId, fields }) => {
    return _.pick(journeys.get(journeyId).stops[stopId], fields);
  }
);

const __getGroupedByDate = createSelectorDeep(
  (state) => state.journeys.groupedData,
  (groupedByDate) => groupedByDate
);

export const getJourneyReviewStatus = createSelector(
  getReviewStatus,
  _getJourneySelectorProps,
  (reviewStatus, { journeyId }) => reviewStatus[journeyId]
);

const getNextPageLink = (state) => state.journeys.nextLink;
const getIsJourneysLoading = (state) => state.journeys.loading;
const getIsJourneysError = (state) => !!state.journeys.error;
const getIsMounted = (state) => state.journeys.mounted;
const getJourneysSummaryModalProps = (state) => state.journeys.journeysSummaryModal;
const getIsNextPageLoading = (state) => state.journeys.loadingNextPage;

export {
  getPlainData,
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
  getTotalsByDate,
  getTotalsByDriver,
  getMunicipalities,
  getTotalByNoOwner,
  getCostByDate,
  __getGroupedByDate,
  getNextPageLink,
  getIsJourneysLoading,
  getIsJourneysError,
  getIsMounted,
  getJourneysSummaryModalProps,
  getIsNextPageLoading,
};
